module.exports = __webpack_public_path__ + "static/media/liveroom-vip-card.a03e59dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/liveroom/liveroom-vip-card.png
// module id = 1951
// module chunks = 6